import axios from 'axios';

export const setDefaultBaseUrl = () => {
  axios.defaults.baseURL = process.env.REACT_APP_BACKEND_HOST;
};
